import * as type from './constant';

export const getUser = (params = undefined, selfRole = undefined) => ({
  type: type.GET,
  params,
  selfRole,
});

export const getUserSuccess = (payload) => ({
  type: type.GET_SUCCESS,
  payload,
});

export const getUserError = (error) => ({
  type: type.GET_ERROR,
  error,
});

export const addUser = (payload, selfRole = undefined) => ({
  type: type.ADD,
  payload,
  selfRole
});

export const addUserSuccess = (payload) => ({
  type: type.ADD_SUCCESS,
  payload,
});

export const updateUser = (id, payload, selfRole = undefined) => ({
  type: type.UPDATE,
  id,
  payload,
  selfRole,
});

export const updateUserSuccess = (payload) => ({
  type: type.UPDATE_SUCCESS,
  payload,
});

export const deleteUser = (ids, selfRole = undefined) => ({
  type: type.DELETE,
  ids,
  selfRole,
});

export const deleteUserSuccess = (payload) => ({
  type: type.DELETE_SUCCESS,
  payload,
});

export const manipulationUserError = (error) => ({
  type: type.MANIPULATION_ERROR,
  error,
});

export const getUserPermission = (role = undefined) => ({
  type: type.GET,
  role,
});

export const getUserPermissionSuccess = (payload, role = '') => ({
  type: type.GET_SUCCESS,
  payload,
  role,
});

export const restoreUserPermission = (ids) => ({
  type: type.RESTORE_PERMISSIONS,
  ids,
});

export const restoreUserPermissionSuccess = (payload) => ({
  type: type.RESTORE_PERMISSIONS_SUCCESS,
  payload,
});

export const generateUserPasswordlessToken = (id) => ({
  type: type.PASSWORDLESS_TOKEN,
  id,
});

export const generateUserPasswordlessTokenSuccess = (id, payload) => ({
  type: type.PASSWORDLESS_TOKEN_SUCCESS,
  id,
  payload,
});
